// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ImportResource extends Resource {
    basePath: string = 'services/import/';

    objectPath: string = 'services/import/{ident}/';
}
